import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Category, Product, ProductUpload } from '../../models/models-vm';
import { MasterService } from '../../services/master.service';
import { MessageService } from '../../../project-intake/services/message.service';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { ErrorLoggerService } from '../../../shared/services/error-logger.service';
import { StorageService } from '../../../Common/services/storage.service';
import { UserLogin } from '../../../Common/models/user.login';
import { ProductMessageConstants } from '../../../Common/Constants/data';
import * as ExcelJS from 'exceljs';
import { MasterFileUploadComponent } from '../master-file-upload/master-file-upload.component';
declare var $: any;

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-master-products',
  templateUrl: './master-products.component.html',
  styleUrls: ['./master-products.component.css', './../../../../assets/css/master_management.css'],
})
export class MasterProductsComponent implements OnInit, OnDestroy {

  private LOADER_ID: string = 'admnproductmasterloader';
  categoriesList: Category[] = [];
  orgProductsList: Product[] = [];
  productsList: Product[] = [];
  filteredProducts: Product[] = [];
  filteredParentProducts: any[] = [];
  productUploadErrors: any[] = [];

  isActiveOptions = [
    { value: 1, label: 'All' },
    { value: 2, label: 'Yes' },
    { value: 3, label: 'No' },
  ];

  chunkSize = 1000;
  currentChunkIndex = 0;
  selProd: Product | undefined | null;
  productForm!: FormGroup;
  currentProductID?: number | null;
  buttonText = 'Add / Update';
  noRecordsFound: string = 'No records found';
  allowedFileTypeExtensions: string = '.xlx,.xlsx';
  loggedInUserID: number = 0;
  fileToUpload: { name: string, base64: string } | null = null;
  showCategories: boolean = false;
  @ViewChild(MasterFileUploadComponent) resetFileInput!: MasterFileUploadComponent;
  srcFileComponent: string = 'products';

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    private masterService: MasterService,
    private msgService: MessageService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private ngxService: NgxUiLoaderService
  ) { }

  async ngOnInit() {
    await this.initForm();
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.loggedInUserID = userRoleInfo.userID;
    }
    await this.loadInitialData();

    // this.productForm.get('searchControl')?.valueChanges.subscribe((searchTerm) =>
    //   this.filterProducts(searchTerm)
    // );

    this.productForm.get('parentProduct')?.valueChanges.subscribe(value => {
      if (value === '' || value === null) {
        this.filteredParentProducts = []; // Clear the suggestions when input is empty
        // You can also perform additional actions here if needed
        this.productForm.get('parentID')?.setValue(0);
      }
    });

    // TODO: commented because on every chaecter typed dont want to search result
    // as it is taking time as it has currently 18500 records and at one strech getting the results
    // so on image icon click we are searching the result at cleint side only
    //
    // this.productForm.get('searchControl')?.valueChanges.pipe(
    //   debounceTime(300), // Wait 300ms after the last keystroke
    //   distinctUntilChanged() // Only emit if the value has changed
    // ).subscribe((searchTerm) => {
    //   this.filterProducts(searchTerm);
    // }); 
  }

  searchClicked() {
    const searchTerm = this.productForm.get('searchControl')?.value;
    this.filterProducts(searchTerm);
  }

  onEnterForSearch(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    const searchTerm = this.productForm.get('searchControl')?.value;
    this.filterProducts(searchTerm);
  }

  onEnterForAddUpdate(event: Event) {
    event.preventDefault();
  }

  private async initForm() {
    this.productForm = this.fb.group({
      productID: [null],
      categoryID: [0, [Validators.required, this.nonZeroValidator]],
      productTitle: ['', Validators.required],
      upc: ['', Validators.required],
      vendorItemNumber: ['', Validators.required],
      dupVendorItemNumber: [''],
      parentID: [0, [Validators.pattern(/^\d+$/)]],
      isActive: [true],
      isVerified: [true],
      categoryIDFilter: [0],
      isActiveFilter: [1],
      isVerifiedFilter: [1],
      searchControl: [''],
      parentProduct: [null]
    });
  }

  private nonZeroValidator(control: AbstractControl) {
    return control.value !== 0 ? null : { nonZero: true };
  }

  private async loadInitialData() {
    this.loadProducts();
    this.ngxService.start(this.LOADER_ID);
    await this.loadCategories();
    // await this.loadProducts(async () => await this.onApplyFilter());    
    await this.onApplyFilter()
  }

  loadNextChunk() {
    const nextChunk = this.getProductsChunk(this.currentChunkIndex, this.chunkSize);
    this.filteredProducts = [...this.filteredProducts, ...nextChunk];
    this.currentChunkIndex++;
  }

  getProductsChunk(chunkIndex: number, chunkSize: number): Product[] {
    const start = chunkIndex * chunkSize;
    const end = start + chunkSize;

    //Filter the products based on the selected category id
    let selectedCategoryIDFilter = this.productForm.get('categoryIDFilter')?.value ?? 0;
    if (selectedCategoryIDFilter > 0) {
      return this.productsList.filter(x => x.categoryID == selectedCategoryIDFilter).slice(start, end);
    }

    return this.productsList.slice(start, end);
  }

  onScroll() {
    if (this.currentChunkIndex * this.chunkSize < this.productsList.length) {
      this.loadNextChunk();
    }
  }

  // private async loadProducts(callback?: () => void) {
  //   this.masterService.getAllProducts().subscribe({
  //     next: (result) => {
  //       this.orgProductsList = []
  //       this.orgProductsList = result;
  //       //this.filteredProducts = result;
  //       callback?.();
  //     },
  //     error: (error) => this.handleError('Error occurred while fetching products.', error),
  //   });
  // }

  private async loadProducts() {
    this.masterService.getAllProducts().subscribe({
      next: (result) => {
        this.orgProductsList = []
        this.orgProductsList = result;

        //console.log('productsList > filteredProducts 2', this.productsList, this.filteredProducts, this.orgProductsList);
      },
      error: (error) => this.handleError('Error occurred while fetching products.', error),
    });
  }

  private async loadCategories() {
    const encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal) {
      const userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      const selectedVendor = userRoleInfo.vendors[0];

      this.masterService.getAllCategories(selectedVendor.vendorID).subscribe({
        next: (result) => (this.categoriesList = result),
        error: (error) => this.handleError('Error occurred while fetching categories.', error),
      });
    }
    if (this.categoriesList && this.categoriesList.length > 0) {
      this.showCategories = true;
    }
  }

  private filterProducts(searchTerm: string): void {
    if (!searchTerm) {
      this.filteredProducts = [];
      this.filteredProducts = this.productsList;
      this.resetFormFields();
      return;
    }
    const search = searchTerm.toLowerCase();

    //Filter the products based on the selected category id while search
    let selectedCategoryIDFilter = this.productForm.get('categoryIDFilter')?.value ?? 0;
    if (selectedCategoryIDFilter > 0) {
      this.filteredProducts = this.productsList.filter(
        (product) =>
          product.productTitle?.toLowerCase().includes(search) ||
          product.upc?.toLowerCase().includes(search) ||
          product.vendorItemNumber?.toLowerCase().includes(search) &&
          product.categoryID == selectedCategoryIDFilter
      );
    }
    else {
      this.filteredProducts = this.productsList.filter(
        (product) =>
          product.productTitle?.toLowerCase().includes(search) ||
          product.upc?.toLowerCase().includes(search) ||
          product.vendorItemNumber?.toLowerCase().includes(search)
      );
    }

    this.resetFormFields();
  }

  parentProductsFilter(event: AutoCompleteCompleteEvent) {
    this.noRecordsFound = 'No records found.';
    const query = event.query?.toLowerCase() || '';

    if (this.productForm.get('categoryID')?.value >= 0) {
      if (query) {
        let filtered: any[] = [];
        //let query = event.query;

        for (let i = 0; i < (this.orgProductsList as any[]).length; i++) {
          let product = (this.orgProductsList as any[])[i];

          if (product.isActive && product.isVerified) {
            if ((product.productTitle.toLowerCase().includes(query.toLowerCase()))
              || (product.vendorItemNumber.toLowerCase().includes(query.toLowerCase()))
              || (product.upc.toLowerCase().includes(query.toLowerCase()))
            ) {
              if (product.categoryID == this.productForm.get('categoryID')?.value) {
                filtered.push(product);
              }
              else {
                this.noRecordsFound = 'The selected product belongs to another category! please try again.';
              }
            }
          }
        }

        this.filteredParentProducts = filtered;
      } else {
        this.filteredParentProducts = []; // Clear suggestions if no query
      }
    }
    else {
      this.msgService.htmlError("Select a category to begin searching for products");
    }

  }

  onSelect(event: any): void {
    this.selProd = event.value;
    this.productForm.get('parentProduct')?.setValue(this.selProd?.productTitle);
    this.productForm.get('parentID')?.setValue(this.selProd?.productID);

    this.filteredParentProducts = [];
  }

  enableOrDisableProduct(event: any, product: Product): void {
    product.isActive = event.target.checked;
    // if (event.target.checked) {
    //   if (this.productForm.get('isVerified')?.value === false) {
    //     this.msgService.htmlError(`IsActive cannot be true without verification.`);
    //     this.productForm.get('isActive')?.setValue(false);

    //   // // const p1 = this.filteredProducts.find(p => p.productID === product.productID);
    //   // // p1!.isActive = !event.target.checked;
    //   // product.isActive = !event.target.checked;

    //   // // this.filteredProducts.forEach(prd => {
    //   // //     if (prd.productID == product.productID) {
    //   // //         product.isActive = !event.target.checked;
    //   // //     }
    //   // // });

    //   // this.filteredProducts = [...this.filteredProducts];
    //   //   // let prod = this.filteredProducts.filter(x=>x.productID == product.productID);
    //   //   // prod[0].isActive = false;
    //     return;
    //   }
    // }
    // else
    // {      
    //   product.isActive = event.target.checked;
    // }

    this.updateProduct(product, 'Product updated successfully');
  }

  verifyProduct(event: any, product: Product): void {
    product.isVerified = event.target.checked;

    if (event.target.checked == false) {
      product.isActive = false;
    }

    this.updateProduct(product, 'Product verified successfully');
  }

  private updateProduct(product: Product, successMessage: string): void {
    this.ngxService.start(this.LOADER_ID);
    this.masterService.updateProduct(product).subscribe({
      next: (result) => {
        this.loadProducts();
        this.errorLogService.logMessage(result, "updateProduct");
        this.msgService.htmlSuccess(successMessage);
        this.resetSearchAndApplyFilter();
      },
      error: () => this.msgService.htmlError('Failed to update product'),
      complete: () => {
        //this.ngxService.stop(this.LOADER_ID)
      },
    });
  }

  private resetSearchAndApplyFilter(): void {
    this.productForm.get('searchControl')?.setValue('');
    this.onApplyFilter();
  }

  private handleValidationErrors(): void {
    const keyMap: any = {
      categoryID: 'Category',
      productTitle: 'Product Title',
      upc: 'UPC',
      vendorItemNumber: 'Vendor Item Number'
    };

    if (this.productForm.get('categoryID')?.value === 0) {
      this.productForm.get('categoryID')?.setErrors({ required: true });
    }

    const errors = Object.keys(this.productForm.controls).reduce((acc, key) => {
      const controlErrors = this.productForm.get(key)?.errors;
      if (controlErrors) {
        if (controlErrors['required']) acc.push(`${keyMap[key]} is required.`);
        if (controlErrors['pattern']) acc.push(`${key} must be a valid number.`);
      }
      return acc;
    }, [] as string[]);

    if (errors.length) {
      this.msgService.htmlError(errors.join('<br/>'));
    }
  }

  onSubmit(): void {
    if (this.productForm.invalid) {
      this.handleValidationErrors();
      return;
    }

    if (this.productForm.get('isActive')?.value === true) {
      if (this.productForm.get('isVerified')?.value === false) {
        this.msgService.htmlError(`IsActive cannot be true without verification.`);

        return;
      }
    }

    const product: Product = this.productForm.value;

    this.ngxService.start(this.LOADER_ID);

    this.errorLogService.logMessage(product, ' Before Save');

    if (this.currentProductID) {
      this.masterService.updateProduct(product).subscribe({
        next: (result) => {

          //PRODUCT_WITH_SAME_VENDOR_NO_EXISTS
          if (result == 3) {
            this.msgService.htmlInfo('Product with same Vendor Item # is already exists.');
            this.ngxService.stop(this.LOADER_ID);
          }
          else {
            this.msgService.htmlSuccess('Product updated successfully');
            this.errorLogService.logMessage(result, "OnSubmit > updateProduct");
            this.loadProducts();
            this.resetForm();
            this.onApplyFilter();
          }
        },
        error: (err) => this.handleError('Failed to update product', err),
        complete: () => {
          // this.ngxService.stop(this.LOADER_ID)
        },
      });
    } else {
      this.masterService.addProduct(this.prepareNewProduct(product)).subscribe({
        next: (result) => {

          //PRODUCT_WITH_SAME_VENDOR_NO_EXISTS
          if (result == 3) {
            this.msgService.htmlInfo('Product with same Vendor Item # is already exists.');
            this.ngxService.stop(this.LOADER_ID);
          }
          else {
            this.msgService.htmlSuccess('Product added successfully');

            this.errorLogService.logMessage(result, "OnSubmit > addProduct");
            this.loadProducts();
            this.resetForm();
            this.onApplyFilter();
          }
        },
        error: (err) => this.handleError('Failed to add product', err),
        complete: () => {
          // this.ngxService.stop(this.LOADER_ID)
        },
      });
    }
  }

  private prepareNewProduct(product: Product): Product {
    return {
      ...product,
      isActive: true,
      isVerified: true,
      parentID: 0,
    };
  }

  editProduct(productID: number): void {
    this.currentProductID = productID;
    const product = this.productsList.find((p) => p.productID === productID);
    if (product) {
      this.productForm.patchValue(product);
      let abc = this.productForm.value;

      this.buttonText = 'Add / Update';
    }
  }

  resetForm(): void {
    this.currentProductID = null;
    this.productForm.reset({
      isActive: 1,
      isVerified: 1,
      categoryIDFilter: 0,
      isActiveFilter: 1,
      isVerifiedFilter: 1,
    });
    this.buttonText = 'Add / Update';
  }

  resetFormFields() {
    this.productForm.get('productID')?.setValue(null);
    this.productForm.get('categoryID')?.setValue(0);
    this.productForm.get('productTitle')?.setValue('');
    this.productForm.get('upc')?.setValue('');
    this.productForm.get('vendorItemNumber')?.setValue('');
    this.productForm.get('parentID')?.setValue(0);
    this.productForm.get('isActive')?.setValue(false);
    this.productForm.get('isVerified')?.setValue(false);
  }

  async onApplyFilter(isFilterClicked: boolean = false) {

    const { categoryIDFilter, isActiveFilter, isVerifiedFilter } = this.productForm.value;

    if (isFilterClicked) {
      // if(categoryIDFilter <= 0)
      // {
      //   this.msgService.htmlWarning('Please select category to filter.');
      //   return;
      // }      
      this.resetFormFields();
      this.productForm.get('parentProduct')?.setValue(null);
      this.productForm.get('parentID')?.setValue(0);
      this.ngxService.start(this.LOADER_ID);
    }


    this.productForm.get('searchControl')?.setValue('');
    this.productsList = [];
    this.filteredProducts = [];

    this.masterService.getProductsByCategory(categoryIDFilter, isActiveFilter, isVerifiedFilter).subscribe({
      next: (result) => {
        this.productsList = result;
        //this.filteredProducts = result;
        this.currentChunkIndex = 0
        this.loadNextChunk();
      },
      error: (error) => this.handleError('Error occurred while fetching filtered products.', error),
      complete: () => {
        //this.ngxService.stop()
        this.ngxService.stop(this.LOADER_ID);
      },
    });
  }

  ngOnDestroy() {
    this.orgProductsList = [];
    this.productsList = [];
    this.filteredProducts = [];
    this.filteredParentProducts = [];
  }

  private handleError(message: string, error: any): void {
    this.msgService.htmlError(message);
    this.errorLogService.logErrorNew(message, error);
    //this.ngxService.stop();
  }

  onFilesChanged(files: Array<{ name: string, base64: string }>) {
    this.fileToUpload = null;
    if (files[0].name !== 'Invalid' && files[0].base64 != '') {
      // this.uploadProducts(files[0].name, files[0].base64);
      this.fileToUpload = files[0];
    }
    else {
      this.msgService.htmlError(ProductMessageConstants.PRODUCT_INVALID_EXCEL);
    }
  }

  productBulkUpload() {
    // Check if file data is available
    if (this.fileToUpload) {
      this.uploadProducts(this.fileToUpload.name, this.fileToUpload.base64);
    } else {
      this.msgService.htmlError('No file selected or invalid file.'); // Show error if no file selected
    }
  }

  uploadProducts(fileName: string, base64: string) {
    let objProducts = new ProductUpload();
    objProducts.DocumentObj = base64.substr(base64.indexOf(',') + 1);
    objProducts.DocumentName = fileName;
    objProducts.CreatedBy = this.loggedInUserID;
    this.ngxService.start();
    this.masterService.UploadProducts(objProducts).subscribe(res => {
      this.productUploadErrors = res;
      this.resetFileInput.resetFileInput();
      if (this.productUploadErrors && this.productUploadErrors.length > 0) {
        // If errors are found, automatically trigger the download of the Excel file
        this.msgService.htmlSuccess(ProductMessageConstants.PRODUCT_PARTIAL_UPLOAD_SUCCESS);
        this.exportErrorsToExcel();
      } else {
        this.msgService.htmlSuccess(ProductMessageConstants.PRODUCT_UPLOAD_SUCCESS);
      }
      this.fileToUpload = null;
      this.loadInitialData();
      this.ngxService.stop();
    });
  }

  downloadFile(blob: Blob, filename: string): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }

  exportErrorsToExcel() {
    if (this.productUploadErrors && this.productUploadErrors.length > 0) {
      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Upload Errors');

      // Add column headers to the worksheet
      worksheet.columns = [
        { header: 'Product Name', key: 'productTitle', width: 30 },
        { header: 'Item Number', key: 'itemNumber', width: 20 },
        { header: 'UPC', key: 'upc', width: 20 },
        { header: 'Error Message', key: 'errorMessage', width: 32 }
      ];

      // Add rows of errors to the worksheet
      this.productUploadErrors.forEach(error => {
        worksheet.addRow({
          productTitle: error.productTitle,
          errorMessage: error.errorMessage,
          itemNumber: error.itemNumber,
          upc: error.upc,
        });
      });

      // Write the workbook to a buffer and trigger download
      workbook.xlsx.writeBuffer().then((buffer: any) => {
        if (buffer) {
          // Create Blob from the buffer
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          this.downloadFile(blob, 'ProductUploadErrors.xlsx');
        } else {
          console.error("Failed to generate Excel buffer");
        }
      }).catch((err: any) => {
        console.error("Error writing Excel file: ", err);
      });
    } else {
      this.msgService.htmlError("No errors to export.");
    }
  }

  // Method to download sample Excel file
  downloadSampleExcel() {
    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Export');

    // Define the column headers with keys
    worksheet.columns = [
      { header: 'Cust Vendor Number', key: 'customerVendorNumber', width: 25 },
      { header: 'Sector', key: 'sector', width: 20 },
      { header: 'Sub Sector', key: 'subSector', width: 20 },
      { header: 'Cust Department Sub Category', key: 'customerDepartmentSubCategory', width: 30 },
      { header: 'Cust UPC Barcode', key: 'upc', width: 20 },
      { header: 'Cust Item Number', key: 'vendorItemNumber', width: 20 },
      { header: 'Cust Item Description', key: 'productTitle', width: 30 },
      { header: 'PG Std Product Name', key: 'pgStdProductName', width: 30 }
    ];

    // Optionally add a sample row to help users understand the format
    worksheet.addRow({
      customerVendorNumber: '047497',
      sector: 'D02',
      subSector: 'Hair Care',
      customerDepartmentSubCategory: 'Mens Conditioners',
      upc: '0081002629001',
      vendorItemNumber: '597786334',
      productTitle: 'Sample Product',
      pgStdProductName: 'Standard Product Name'
    });

    // Write the workbook to a buffer and trigger download
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      if (buffer) {
        // Create a Blob from the buffer
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        this.downloadFile(blob, 'Product_Upload_Template.xlsx');
      } else {
        console.error("Failed to generate Excel buffer for sample download");
      }
    }).catch((err: any) => {
      console.error("Error writing sample Excel file: ", err);
    });
  }


}
